/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useHUSpinStyles = makeStyles({
  root: {
    position: 'relative',
  },
  spin: {
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    top: '50%',
    left: '50%',
    padding: '10px',
    transform: 'translate(-50%, -50%)',
    flexDirection: 'column',
    zIndex: 1,
  },
  container: {
    transition: 'filter .3s linear, opacity .3s linear',
    '$root$spinning &': {
      opacity: '0.5',
      userSelect: 'none',
      pointerEvents: 'none',
      filter: 'blur(0.5px)',
    },
  },
  spinning: {},
  tip: {
    marginTop: '15px',
    fontSize: '16px',
    lineHeight: '22px',
    fontWeight: 'bold',
    color: '#F16623',
  },
});
